// @mui
import {
  Card,
  Box,
  Stack,
  Typography,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
// utils
import { fKrTrackingTimeShortKST } from "../../utils/formatTime";


export default function TimeTracker ({ currentData }) {
  const smUp = useResponsive('up', 'sm');

  const pastTime = currentData?.start_at ? new Date().getTime() - new Date(currentData?.start_at).getTime() : 0;
  const hours = Math.floor(pastTime / (1000 * 60 * 60));
  const minutes = Math.floor((pastTime % (1000 * 60 * 60)) / (1000 * 60));

  return (
    <Card sx={{ height: '100%', maxHeight: 167, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Box
        sx={{
          px: { xs: 3, sm: 5},
          py: { xs: 3, sm: 4},
        }}
      >
        <Stack direction="column" spacing={smUp ? 1 : 0.5}>
          <Stack direction="row" spacing={1} alignItems="center">
            <SvgIconStyle src={`/icons/ic_clock.svg`} sx={{ width: 20, height: 20, color: "secondary.main" }} />
            <Typography variant="subtitle1" sx={{ color: "secondary.main" }}>
              {hours > 0 ? `${hours}시간` : ""} {minutes}분 근무중
            </Typography>
          </Stack>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {fKrTrackingTimeShortKST(currentData.start_at)} ~
          </Typography>
        </Stack>
      </Box>
    </Card>
  )
}
